import { sortBySequenceNumber } from 'shared/lib/common-util'
import { fromDocumentResponse } from '../../document/models/responseToModel'
import { DocumentUpdate } from '../../document/models/request'
import { Document } from '../../document/models/types'
import { toUpdateDocumentRequests } from '../models/mapper'
import { updateHouseConsignmentDocumentsV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function updateHouseConsignmentDocuments(
  transitOperationId: number,
  houseConsignmentId: number,
  documents: DocumentUpdate[],
): Promise<Document[]> {
  const requests = toUpdateDocumentRequests(documents, transitOperationId, houseConsignmentId)
  if (requests.length === 0) {
    return []
  }

  const responses = await updateHouseConsignmentDocumentsV3(houseConsignmentId, requests)
  return responses.map((r, i) => fromDocumentResponse(r, i)).sort(sortBySequenceNumber)
}
